import { siteConfig } from '@/mocks/siteData';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedContent from './components/FeaturedContent';
import CategoryNavigation from './components/CategoryNavigation';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
    },
    {
      '@type': 'WebSite',
      name: siteConfig.name,
      url: siteConfig.url,
      description: siteConfig.description,
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteConfig.url}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: `${siteConfig.name} - 首页`,
      url: siteConfig.url,
      description: siteConfig.description,
      isPartOf: {
        '@id': `${siteConfig.url}/#website`,
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(homeJsonLd)}</script>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedContent />
        <CategoryNavigation />
        <LatestUpdates />
        <CTASection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}